import { render, staticRenderFns } from "./serviceItemHome.vue?vue&type=template&id=6fef261e&"
var script = {}
import style0 from "./serviceItemHome.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fef261e')) {
      api.createRecord('6fef261e', component.options)
    } else {
      api.reload('6fef261e', component.options)
    }
    module.hot.accept("./serviceItemHome.vue?vue&type=template&id=6fef261e&", function () {
      api.rerender('6fef261e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/services/serviceItemHome/serviceItemHome.vue"
export default component.exports